function bindProductLinks() {
  document.querySelectorAll('.product-card__link').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.location.href = this.getAttribute('href'); 
    });
  });
}

// Initial bind
bindProductLinks();

// Rebind after AJAX
document.addEventListener("products:loaded", bindProductLinks); 


  function openShareModal() {
    document.getElementById("shareOverlay").style.display = "flex";
  }

  function closeShareModal() {
    document.getElementById("shareOverlay").style.display = "none";
  }

  window.addEventListener('click', function(e) {
    var overlay = document.getElementById('shareOverlay');
    var modal = document.querySelector('.share-box-modal');
    if (e.target === overlay) {
      overlay.style.display = 'none';
    }
  });

  function copyProductLink() {
    const copyText = document.getElementById("product-share-link");
    const copyBtn = event.target;
    
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand("copy");

    // Change button text temporarily
    const originalText = copyBtn.innerText;
    copyBtn.innerText = "Copied!";
    copyBtn.disabled = true;

    setTimeout(() => {
      copyBtn.innerText = originalText;
      copyBtn.disabled = false;
    }, 1500);
  }



  //- ------- Shop mega menu -------

document.addEventListener("DOMContentLoaded", function () {
  // --- Toggle mega menu ---
  const shopBtn = document.getElementById("shopToggle");
  const megaMenu = document.getElementById("megaMenu");

  if (shopBtn && megaMenu) {
    shopBtn.addEventListener("click", (e) => {
      e.preventDefault();
      megaMenu.classList.toggle("active");
    });

    document.addEventListener("click", (e) => {
      if (!shopBtn.contains(e.target) && !megaMenu.contains(e.target)) {
        megaMenu.classList.remove("active");
      }
    });
  }

  // --- Columns ---
  const currentPath = window.location.pathname;
  const col1 = document.getElementById("shopMenuCol1");
  const col2 = document.getElementById("shopMenuCol2");
  const col3 = document.getElementById("shopMenuCol3");

  // 🟩 EASY MENU CONTROL
  const menuItems = [
    // COLUMN 1
    { title: "Makhana", url: "/collections/makhana", col: 1 },
    { title: "Dry Fruits", url: "/collections/dry-fruits", col: 1 },
    { title: "Seeds", url: "/collections/seeds", col: 1 },
    { title: "Berries", url: "/collections/berries", col: 1 },
    { title: "View All", url: "/collections/all", col: 1 }, // last in col1

    // COLUMN 2
    { title: "Breakfast Essential", url: "/collections/breakfast-essential", col: 2 },
    { title: "Winter Essentials", url: "/collections/winter-essentials", col: 2 },
    { title: "Daily Essential", url: "/collections/daily-essential", col: 2 },
    { title: "King Essentials", url: "/collections/king-essentials", col: 2 },
    { title: "Travelling  Essential", url: "/collections/travelling-essential", col: 2 },

    // COLUMN 3
    { title: "Mens Essentials", url: "/collections/mens", col: 3 },
    { title: "Womens Essentials", url: "/collections/womens", col: 3 },
    { title: "Kids Essentials", url: "/collections/kids", col: 3 },
    { title: "Seniors Essentials", url: "/collections/seniors", col: 3 },
    { title: "Treasure of Arabia", url: "/collections/treasure-of-arabia", col: 3 }, // last in col3
  ];

  // 🖼️ ICONS + TAGLINES (for all)
  const itemConfig = {
    "makhana": {
      tagline: "Start your day with energy!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/1_bf518bd4-c9aa-4700-8202-43d9e03d272b.png?v=1758480690",
    },
    "dry fruits": {
      tagline: "Crunchy goodness for health!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/3_1c597e3c-c770-4353-ba74-8f3212a96f5c.png?v=1758458747",
    },
    "seeds": {
      tagline: "Fuel your body naturally!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/21.png?v=1758485426",
    },

    "berries": {
      tagline: "Fuel your body naturally!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Daily_Essential.png?v=1756277902",
    },
    
    "breakfast essential": {
      tagline: "Start strong every morning!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Gemini_Generated_Image_j8svwbj8svwbj8sv.webp?v=1758675340",
    },
    "winter essentials": {
      tagline: "Warm up with nature’s goodness!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/WINTER.png?v=1759675433",
    },
    "daily essential": {
      tagline: "Everyday must-haves!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Gemini_Generated_Image_rudh26rudh26rudh.webp?v=1758675724",
    },
    "king essentials": {
      tagline: "Royal picks for your lifestyle!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_c3008716-59ea-4c8b-a63b-7c8cad3f40cd.webp?v=1758675783",
    },
    "travelling  essential": {
      tagline: "Companions for your journey!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/8f8cdd2e8cee8b82be4a5846a60946d3.webp?v=1758793187",
    },
    "mens essentials": {
      tagline: "Power-packed bites for him!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Men_e181061a-95c2-4b0f-87ed-d551a054425d.png?v=1758543809",
    },
    "womens essentials": {
      tagline: "Nourishment that celebrates her!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Women_56d5ab17-dd51-4916-b288-9c27e831d06b.png?v=1758543809",
    },
    "kids essentials": {
      tagline: "Little bites, big energy!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Kids_1.png?v=1758602199",
    },
    "seniors essentials": {
      tagline: "Comfort and care for seniors!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/Seniors_8af681fc-c6b0-40b4-a2e6-03b807f21369.png?v=1758543809",
    },
    "treasure of arabia": {
      tagline: "A taste of tradition!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/PremiumDriedFigsF_d8e812fe-2907-4bf2-8a17-6cad831f2249.webp?v=1758676600",
    },
    "view all": {
      tagline: "Explore our full range!",
      icon: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/alot_3_png-8.png?v=1748167674",
    },
  };

  // --- GENERATE CARDS ---
  menuItems.forEach((item) => {
    const key = item.title.trim().toLowerCase();
    const config = itemConfig[key] || { tagline: "", icon: "" };

    const card = document.createElement("div");
    card.className = "menu-card d-flex align-items-center mb-3";
    card.style.cursor = "pointer";
    card.dataset.url = item.url;

    card.innerHTML = `
      <div class="menu-img">
        <img src="${config.icon}" alt="${item.title}" loading="lazy">
      </div>
      <div class="menu-text ms-3">
        <div class="menu-title">${item.title}</div>
        <small class="menu-tagline">${config.tagline}</small>
      </div>
    `;

    card.addEventListener("click", () => (window.location.href = item.url));

    // --- Column placement ---
    if (item.col === 1) col1.appendChild(card);
    else if (item.col === 2) col2.appendChild(card);
    else col3.appendChild(card);

    // --- Active highlight ---
    if (currentPath === item.url || currentPath.startsWith(item.url)) {
      card.classList.add("active");
    }
  });
});








// ======= USP ICONS ========= 


  // document.addEventListener("DOMContentLoaded", function () {
  //   const uspBox = document.getElementById("usp-box");

  //   // Define USP images for different products
  //   const uspData = {
  //     "/products/natural-makhana-fox-nuts-phool-makhana": [
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/1_523e0ad9-bc06-4243-8ca6-7374a2a058b5.png?v=1756288133" },
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/2_62be40e4-4aa7-457a-b054-08db3d93fe49.png?v=1756288132" },
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/3_c41a7b30-c329-46cb-9d18-eecda75de84c.png?v=1756288133"},
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_d1767dac-a479-4554-9bd8-c07b46806f0b.png?v=1756288133"},
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/5_2fe971ff-30e7-478c-9038-fdcee57a211c.png?v=1756288133"},
  //       { img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/6_b5a5f682-2ef6-4be5-83c7-c9c99238ece0.png?v=1756288133"}
  //     ],
  //     "/products/natural-makhana-fox-nuts-phool-makhana-pink": [
        
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/2_f43389de-71b5-4d5e-ada3-3b8617dbd030.png?v=1756289544"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/1_33f8ce5e-9e37-422b-8365-b1beb08c5861.png?v=1756289544"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_2894e6bb-b658-4cad-b2c8-1ac43545ad8c.png?v=1756289544"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/5_43e6338c-4330-4157-9823-85ea05cb8999.png?v=1756289544"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/3_c0d9dbfb-b1c8-454d-a649-254c24c0a809.png?v=1756289544"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/6_03c06e9a-37cf-488e-b093-2cddac1b9cdc.png?v=1756289545"}
  //     ],
  //     "/products/natural-makhana-fox-nuts-phool-makhana-green": [
        
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_32561cb5-537d-4f66-9b9d-ed65cf676af0.png?v=1756290804"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/1_2324a48c-aa46-4065-b2f8-bcebcf0c2d6a.png?v=1756290803"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/3_58973c1c-8958-45a0-b40a-751af3123d4c.png?v=1756290803"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_32561cb5-537d-4f66-9b9d-ed65cf676af0.png?v=1756290804"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/5_368ef15b-bfed-4b30-bf26-02ad25fddf5a.png?v=1756290804"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/6_07ee8753-d37a-4520-9eb9-a8126b631732.png?v=1756290803"}
  //     ],
  //     "/products/natural-makhana-fox-nuts-phool-makhana-purple": [
        
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/1_900e92bd-5943-472d-91e8-f32df8c1d713.png?v=1756291789"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/2_55945b3c-0cc1-4b82-8371-92260d0d6b00.png?v=1756291789"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/3_e98f7347-f754-45f5-b504-8f1487b85ac7.png?v=1756291789"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/4_83228437-5d77-47a8-93d4-1a2996328df4.png?v=1756291789"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/5_087b350d-a6f3-4d64-8f64-a31dfd65e5a6.png?v=1756291789"},
  //       {img: "https://cdn.shopify.com/s/files/1/0447/7455/5805/files/6_d97f0733-7d01-41bf-a59d-c2653a372ebb.png?v=1756291790"}
  //     ],
      
  //   };

  //   const currentPath = window.location.pathname;
  //   const usps = uspData[currentPath];

  //   if (usps) {
  //     usps.forEach(item => {
  //       const div = document.createElement("div");
  //       div.className = "usp-item text-center";
  //       div.style.maxWidth = "100px";

  //       div.innerHTML = `
  //         <img src="${item.img}" alt="${item.text}" style="width:110px;height:110px; max-width:100px; object-fit:contain;">
  //       `;

  //       uspBox.appendChild(div);
  //     });
  //   }
  // });


  


document.addEventListener("DOMContentLoaded", function() {
  const buttons = document.querySelectorAll(".accordion-button");

  buttons.forEach(btn => {
    let icon = btn.querySelector(".accordion-icon");
    let targetId = btn.getAttribute("data-bs-target");
    let target = document.querySelector(targetId);

    target.addEventListener("shown.bs.collapse", function() {
      icon.textContent = "-";
    });

    target.addEventListener("hidden.bs.collapse", function() {
      icon.textContent = "+";
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
  const detailsList = document.querySelectorAll("accordion-custom details");

  detailsList.forEach(details => {
    details.addEventListener("toggle", () => {
      const plusIcon = details.querySelector(".icon-plus .horizontal");

      if (details.open) {
        // hide horizontal line → show minus
        if (plusIcon) plusIcon.style.opacity = "0";
      } else {
        // show horizontal line → back to plus
        if (plusIcon) plusIcon.style.opacity = "1";
      }
    });
  });
});



document.addEventListener("DOMContentLoaded", function () {
  function formatRupee(num) {
    return "₹" + Math.round(num).toLocaleString("en-IN");
  }

  // Loop through every tag-line-cut block
  document.querySelectorAll(".tag-line-cut").forEach(function (tagLine) {
    const priceEl = tagLine.querySelector(".custline");
    const discountEl = tagLine.querySelector(".discounted-price");

    if (priceEl && discountEl) {
      // Extract numeric price
      const priceText = priceEl.textContent.replace(/[^\d.]/g, "");
      const price = parseFloat(priceText);

      if (!isNaN(price) && price > 0) {
        // Calculate 10% off
        const discountPrice = price - price * 0.10;

        // Put discounted price (no double ₹)
        discountEl.textContent = Math.round(discountPrice).toLocaleString("en-IN");
      } else {
        console.warn("Price not valid in:", tagLine);
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
    
    // Helper function for professional Rupee formatting (e.g., ₹1,234)
    function formatRupee(num) {
        return num.toLocaleString('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0 // Shows whole numbers (no decimal points)
        });
    }

    // Process all elements that contain the original price
    document.querySelectorAll(".discounted-btn-price").forEach(function (el) {
        
        // Find the main card container (crucial for finding the discount display element)
        let card = el.closest(".product-card") || 
                   el.closest(".card") || 
                   el.closest("button") || 
                   el.parentElement;
        
        if (!card) return;

        // Find the element where the discounted price will be displayed
        let discountedPriceEl = card.querySelector(".discounted-price");

        if (discountedPriceEl) {
            // Robustly extract the base price number
            let priceText = el.textContent || el.innerText;
            let basePriceString = priceText.replace(/,/g, "").replace(/[^\d.]/g, "");
            let basePrice = parseFloat(basePriceString);

            if (!isNaN(basePrice) && basePrice > 0) {
                // Calculate 10% off
                let finalPrice = basePrice * 0.90; 

                // Update the text with the correctly formatted Rupee price
                discountedPriceEl.textContent = formatRupee(finalPrice);
            }
        }
    });
});



document.addEventListener("DOMContentLoaded", function () {
    
    // 1. Define the core function to apply the discount
    function applyDiscountToProducts(targetNode) {
        // Search only within the provided targetNode (or the whole document if none provided)
        const root = targetNode || document;
        
        // Use a robust selector to find the base price element
        root.querySelectorAll(".discounted-btn-price").forEach(function (el) {
            
            // Find the closest product card container
            let card = el.closest(".product-card") || 
                       el.closest(".card") || 
                       el.parentElement;
            
            if (!card) return;

            let discountedPriceEl = card.querySelector(".discounted-price");

            if (discountedPriceEl) {
                // Robust price extraction
                let priceText = el.textContent || el.innerText;
                let basePriceString = priceText.replace(/,/g, "").replace(/[^\d.]/g, "");
                let basePrice = parseFloat(basePriceString);

                if (!isNaN(basePrice) && basePrice > 0) {
                    let finalPrice = basePrice * 0.90; 

                    // Apply Rupee formatting
                    discountedPriceEl.textContent = finalPrice.toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                        maximumFractionDigits: 0 
                    });
                }
            }
        });
    }

    // 2. Initial run on static content
    applyDiscountToProducts(document);
    
    // 3. Set up MutationObserver to handle dynamically loaded content (Carousels/Related Products)
    //    We observe the body since the carousel could be anywhere.
    const observer = new MutationObserver(function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Run the discount logic on any new nodes added to the DOM
                mutation.addedNodes.forEach(node => {
                    // Check if the added node is an element (type 1)
                    if (node.nodeType === 1) {
                         // We run the function on the newly added node (e.g., the new carousel slide)
                        applyDiscountToProducts(node);
                    }
                });
            }
        }
    });

    // Start observing the body for configuration changes
    observer.observe(document.body, { childList: true, subtree: true });
});



// cupon

// ======= cupon active inctive =========

document.addEventListener("DOMContentLoaded", function () {
  const playBtn = document.getElementById("playVideoBtn");
  const modal = document.getElementById("videoModal");
  const iframe = document.getElementById("vimeoPlayer");
  const closeBtn = document.getElementById("closeVideo");
  const parent = document.querySelector(".video-tsd");

  const vimeoURL =
    "https://player.vimeo.com/video/1127433633?autoplay=1&muted=1&controls=0&title=0&byline=0&portrait=0";
  
  playBtn.addEventListener("click", function () {
    parent.classList.add("active");
    iframe.src = vimeoURL;
    modal.style.display = "flex";
    setTimeout(() => modal.classList.add("active"), 100);

    // 🎧 After autoplay starts, unmute sound
    setTimeout(() => {
      const player = new Vimeo.Player(iframe);
      player.setVolume(1); // full volume
    }, 1500);
  });

  const closeModal = () => {
    modal.classList.remove("active");
    parent.classList.remove("active");
    setTimeout(() => {
      modal.style.display = "none";
      iframe.src = "";
    }, 400);
  };

  closeBtn.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
});






// --------  alot search bar -------------
(function(){
  function addSearch(){
    const box = document.querySelector('.header__column.header__column--right');
    if (!box || box.querySelector('.js-inline-search')) return;

    const form = document.createElement('form');
    form.className = 'js-inline-search';
    form.action = '/search';
    form.method = 'get';
    form.role = 'search';
    form.style.cssText = `
      display:flex;
      gap:.5rem;
      align-items:center;
      margin-right:.5rem;
    `;

    form.innerHTML = `
      <input 
        on:click="#search-modal/showDialog"
        name="q"
        type="search"
        placeholder="Search Makhana…"
        aria-label="Search"
        style="padding:.45rem .7rem;border:1px solid #ddd;border-radius:6px;min-width:250px;font-size:14px;"
      >
      <input type="hidden" name="type" value="product">
      <button type="button" class="shop-now-btn" onclick="window.location.href='/collections/all'">
        Shop Now
      </button>
    `;
    box.prepend(form);

    // --- typing animation ---
    const input = form.querySelector('input[name="q"]');
    const words = ['Makhana', 'Seeds', 'Dry Fruits'];
    let i = 0, j = 0, erasing = false;

    function typeEffect() {
      const word = 'Search ' + words[i];
      if (!erasing) {
        input.placeholder = word.slice(0, j++);
        if (j <= word.length) return setTimeout(typeEffect, 90);
        erasing = true;
        return setTimeout(typeEffect, 1000);
      } else {
        input.placeholder = word.slice(0, --j);
        if (j > 0) return setTimeout(typeEffect, 50);
        erasing = false;
        i = (i + 1) % words.length;
        return setTimeout(typeEffect, 400);
      }
    }

    typeEffect();
  }

  document.addEventListener('DOMContentLoaded', addSearch);
  setTimeout(addSearch, 600);
})();